<template>
  <page title="Programs">
    <tab-switcher id="pg" :tabs="tabs"></tab-switcher>
  </page>
</template>

<script>
import { mapState } from "vuex";

import Page from "@/components/Page.vue";
import TabSwitcher from "@/components/TabSwitcher/TabSwitcher.vue";
import MembershipPrograms from "@/MembershipPrograms/MembershipPrograms.vue";
import WarrantyPrograms from "@/WarrantyPrograms/WarrantyPrograms.vue";
import { getProperty } from "../lib/helpers.js";

export default {
  components: {
    Page,
    TabSwitcher
  },
  computed: {
    ...mapState({
      tabs({ tenant }) {
        const tabs = [
          {
            name: "Memberships",
            component: MembershipPrograms
          },
          {
            name: "Warranties",
            component: WarrantyPrograms,
            visible: getProperty(tenant, "feature_flags.warranty")
          }
        ];
        return tabs;
      }
    })
  }
};
</script>

<style lang="scss" scoped></style>
